import { createAction } from '@reduxjs/toolkit';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const loginRequestAction = createAction(LOGIN_REQUEST);
